/**
 * RESPONSIBILITY: the foundations band on the Leadership page.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { Card } from './rows/card';

@Section({ name: SectionName.LeadershipPillars, label: 'Leadership — foundations' })
export class LeadershipPillarsSection {
  @Text({ label: 'Title', maxLength: 120, default: 'Our foundations' })
  pillarsHeading!: string;

  @List({ label: 'Pillars', of: () => Card, maxItems: 6 })
  pillars!: Card[];

  @Text({
    label: 'Subtitle', maxLength: 120, default: 'What we stand on',
    description: 'The small line above the title.',
  })
  eyebrow!: string;
}
